import { defineStore } from 'pinia';
import { reactive } from 'vue';
import { FilterModalItems } from '../filterModal/filterModal';
import { OrderControlRepository } from '@/coreInfrastructureModule/Repositories/OrderControlRepository';
import { GetRecommendOrderIdsUseCase } from '@/coreUseCasesModule/orderControl/getRecommendOrderIdsUseCase';
import { LoadingState } from '@/coreDomainsModule/uiLoadingState';
import { i18n } from '@/i18n';
import { GetApprovedRequestOrderIdsUseCase } from '@/coreUseCasesModule/orderControl/getApprovedRequestOrderIdsUseCase';

export const useAggregateBusinessIdHasRecommendOrderStore = defineStore('aggregateBusinessIdHasRecommendOrder', () => {
  const state = reactive<IAggregateBusinessIdHasRecommendOrderState>({
    aggregateBusinessIdsHasRecommendOrder: [],
    loadingState: {
      status: {
        type: 'loading',
      },
    },
  });

  const orderControlRepository = new OrderControlRepository();
  const getRecommendOrderIdsUseCase = new GetRecommendOrderIdsUseCase();
  const getApprovedRequestOrderIdsUseCase = new GetApprovedRequestOrderIdsUseCase();

  /**
   * ステートを初期化する
   */
  const $reset = () => {
    state.aggregateBusinessIdsHasRecommendOrder = [];
  };

  /**
   * 推奨情報を持っている集計IDを取得する
   * @param filterItems - フィルターモーダルの項目
   */
  const fetchAggregateBusinessIdsHasRecommendOrder = async (filterItems: FilterModalItems): Promise<string[]> => {
    state.loadingState = {
      status: {
        type: 'loading',
      },
    };

    const result = await getRecommendOrderIdsUseCase.Execute(orderControlRepository, filterItems.selectionFilterItems);

    switch (result.status.type) {
      case 'success':
        state.aggregateBusinessIdsHasRecommendOrder = result.status.data;
        state.loadingState.status.type = 'success';
        return result.status.data;
      case 'error':
        state.loadingState = {
          status: {
            type: 'error',
            errorMessage: '推奨情報を持つ集計ID一覧取得に失敗しました',
          },
        };
        break;
    }
    return [];
  };

  /**
   * 承認依頼情報を持っている集計IDを取得する
   * @param filterItems - フィルターモーダルの項目
   */
  const fetchAggregateBusinessIdsHasApprovedRequestOrder = async (filterItems: FilterModalItems): Promise<string[]> => {
    state.loadingState = {
      status: {
        type: 'loading',
      },
    };

    const result = await getApprovedRequestOrderIdsUseCase.Execute(orderControlRepository, filterItems.selectionFilterItems);

    switch (result.status.type) {
      case 'success':
        state.loadingState.status.type = 'success';
        return result.status.data;
      case 'error':
        state.loadingState = {
          status: {
            type: 'error',
            errorMessage: '推奨情報を持つ集計ID一覧取得に失敗しました',
          },
        };
        break;
    }
    return [];
  };

  return {
    $reset,
    fetchAggregateBusinessIdsHasRecommendOrder,
    fetchAggregateBusinessIdsHasApprovedRequestOrder,
    state,
  };
});

/**
 *  推奨情報を持つ集計ID情報のStoreのstate定義
 */
interface IAggregateBusinessIdHasRecommendOrderState {
  aggregateBusinessIdsHasRecommendOrder: string[];
  loadingState: LoadingState;
}
